// selected variant form key in the form
export const selected_merchandise_variant_form_key = "selected_variant";

// selected merchandise quantity form key in the form
export const selected_merchandise_quantity_form_key = "merchandise_quantity";

// merchandise qunantity default option which is selected by default
export const selected_merchandise_default_value = {
    id: "1",
    label: "Quantity: 1",
    value: "1",
    selectedLabel: "Quantity: 1",
};

// default maximum quantity, incase user has the 'allow overflow' check
// enabled, then we still have to set a max limit
export const merchandise_total_inventory = 100;

// incase shiprocket can not deliver to the pincode error message
export const merchandise_shiprocket_error =
    "Sorry, We can't deliver to this Pin Code";

export const default_shiprocket_data = {
    value: {},
    isVerified: false,
    error: "",
};
